import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './NotFoundPage.css';

function NotFoundPage() {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="notfound">
      <div className="notfound-content">
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">
          {isEn ? 'Page not found' : 'Página no encontrada'}
        </h2>
        <p className="notfound-text">
          {isEn
            ? 'The page you are looking for does not exist or has been moved.'
            : 'La página que buscas no existe o ha sido movida.'}
        </p>
        <Link
          to={isEn ? '/en' : '/'}
          className="notfound-link"
          onClick={() => window.scrollTo(0, 0)}
        >
          {isEn ? 'Back to home' : 'Volver al inicio'}
        </Link>
      </div>
    </section>
  );
}

export default NotFoundPage;
